<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <el-button type="primary" @click="addMenu">添加</el-button>
            </div>
            <el-tabs v-model="query.type" @tab-click="tabClick" type="card">
                <el-tab-pane :name="item.value" :key="index" v-for="(item, index) in menuType" :label="item.label"
                    :index:="index">
                </el-tab-pane>
            </el-tabs>
            <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header"
                style="width: 100%;margin-bottom: 40px;" row-key="ID" default-expand-all
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
                <el-table-column prop="ID" label="ID" width="100" align="center"></el-table-column>
                <el-table-column prop="type" label="菜单类型" align="center">
                    <template #default="scope">
                        {{menuMap.get(scope.row.type)}}
                   </template>
                </el-table-column>
                <el-table-column prop="name" label="菜单名称" align="center"></el-table-column>
                <el-table-column prop="parentId" label="父级菜单ID" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="path" label="路由地址" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="sort" label="排序" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="CreatedAt" :formatter="dateFormat" align="center" label="添加时间"
                    width="200px;"></el-table-column>
                <el-table-column label="操作" width="230" header-align="center">
                    <template #default="scope">
                        <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.row.ID)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog :title="actTitle" width="50%" v-model="editVisible">
            <el-form ref="form" :model="form" class="el-dialog__body model-h" :rules="rules">
                <el-tag type="danger">作为有子菜单的一级菜单不要设置路由地址，否则会影响到菜单分配</el-tag>
                <el-form-item label=" 菜单名称" prop="name" required>
                    <el-input v-model="form.name" style="width: 200px"></el-input>
                </el-form-item>
                <el-form-item label=" 菜单类型" prop="type" required>
                    <el-select v-model="form.type" placeholder="请选择" style="width: 200px;" @change="typeChange" popper-class="el-select-class">
                        <el-option v-for="item in menuType" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="上 级 菜 单">
                    <el-select v-model="form.parentId" placeholder="请选择" style="width: 200px;" transfer="true" :popper-class="false">
                        <el-option v-for="item in parentOptions" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="路 由 地 址">
                    <el-input v-model="form.path" style="width: 200px" placeholder="请输入跳转页面的路由地址"></el-input>
                </el-form-item>
                <el-form-item label="菜 单 排 序">
                    <el-input-number v-model="form.sort" style="width: 200px" :controls="false"></el-input-number>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="editVisible = false">取 消</el-button>
                    <el-button type="primary" @click="saveEdit">确 定</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { createMenu, getAllMenu, removeMenu } from "@/api/menu";
import { ElTableColumn } from "element-plus";

export default {
    name: "UserTable",
    components: { ElTableColumn },
    data() {
        return {
            action: 'https://wx.yixiankeji.com/admin/upload',
            actTitle: "添加",
            form: {
                parentId: 0,
                name: "",
                path: "",
                sort: 0,
                type: 0
            }, //提交表单数据
            tableData: [],
            editVisible: false,
            parentOptions: [{ value: 0, label: '顶级菜单' }],
            menuType: [
                { label: '平台', value: 0 },
                { label: '加盟商', value: 1 },
                { label: '代理商', value: 2 }
            ],
            menuMap:new Map(),
            query: {
                type: 0
            },
            menu_query: {
                type: 0
            },
            rules: {
                name: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
                type: [{ required: true, message: '请选择菜单类型', trigger: 'blur' }]
            },
        };
    },
    mounted() {
        this.getData();
    },
    computed: {
    },
    methods: {
        dateFormat: function (row, column) {
            const date = row[column.property];
            if (date === undefined) {
                return "";
            }
            var time = new Date(date).toJSON();
            return new Date(new Date(time) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
        },
        // 触发搜索按钮
        handleSearch() {
            this.getData()
        },
        getData() {
            getAllMenu(this.query).then(res => {
                if (res.code == 0) {
                    this.tableData = res.data
                }
            })
            this.menuType.forEach(item => {
                this.menuMap.set(item.value, item.label)
            })
        },
        getSelectMenu() {
            this.$nextTick(() => {
                getAllMenu(this.menu_query).then(res => {
                    if (res.code == 0) {
                        let parentOptions = [{ label: '顶级菜单', value: 0 }]
                        res.data.forEach(function (val) {
                            parentOptions.push({ label: val.name, value: Number(val.ID) })
                        }, this)
                        this.parentOptions = parentOptions
                    }
                })
            })
        },
        addMenu() {
            // this.getSelectMenu()
            this.actTitle = "添加"
            this.form = {}
            this.editVisible = true
        },
        handleEdit(index, row) {
            this.menu_query.type = row.type
            this.getSelectMenu()
            this.actTitle = "编辑"
            this.form.parentId = row.parentId
            this.form.path = row.path
            this.form.sort = row.sort
            this.form.type = row.type
            this.form.name = row.name
            this.form.id = row.ID
            this.editVisible = true
        },
        saveEdit() {
            this.form.parentId = Number(this.form.parentId)
            if (this.form.name === '') {
                this.$message.error('请输入菜单名称')
            } else if (!this.form.type && this.form.type != 0) {
                this.$message.error('请选择菜单类型')
            } else if (this.form.parentId != 0 && this.form.path === '') {
                this.$message.error('请输入路由地址')
            } else {
                this.form.sort = Number(this.form.sort)
                createMenu(this.form.id, JSON.stringify(this.form)).then(res => {
                    if (res.code == 0) {
                        this.$message.success(res.msg)
                        this.editVisible = false
                        this.getData()
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        handleDelete(id) {
            this.$confirm("确认删除该记录吗?", "提示", {
                type: "warning",
            })
                .then(() => {
                    removeMenu(JSON.stringify({ id })).then(res => {
                        if (res.code == 0) {
                            this.$message.success(res.msg)
                            this.getData()
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                })
        },
        tabClick() {
            this.getData()
        },
        typeChange() {
            this.menu_query.type = this.form.type
            this.form.parentId = null
            this.getSelectMenu()
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 10px;
}

.red {
    color: #ff0000;
}

.el-select {
    width: 200px;
}
.el-select-class {
    height: 700px !important;
}
</style>